
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("cVVvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f26990cfea7bc9e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $fgZWY = parcelRequire("fgZWY");

var $5uXOq = parcelRequire("5uXOq");

var $ew53Q = parcelRequire("ew53Q");
var $b27Oi = parcelRequire("b27Oi");

var $9RWIk = parcelRequire("9RWIk");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1f26990cfea7bc9e$var$EmojiNode extends (0, $5uXOq.PureComponent) {
    static{
        this.displayName = 'EmojiNode';
    }
    static{
        this.defaultProps = {
            showTooltip: true
        };
    }
    constructor(props){
        super(props), this.renderWithProvider = (providers)=>{
            const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig } = this.props;
            if (allowTextFallback && !providers.emojiProvider) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-emoji-id": id,
                "data-emoji-short-name": shortName,
                "data-emoji-text": fallback || shortName
            }, fallback || shortName);
            if (!providers.emojiProvider) return null;
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fgZWY.default), {
                emojiId: {
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                },
                emojiProvider: providers.emojiProvider,
                showTooltip: showTooltip,
                fitToHeight: fitToHeight,
                optimistic: true,
                optimisticImageURL: resourceConfig?.optimisticImageApi?.getUrl({
                    id: id,
                    fallback: fallback,
                    shortName: shortName
                }),
                editorEmoji: true
            });
        };
        this.providerFactory = props.providers || new (0, $ew53Q.default)();
    }
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $b27Oi.WithProviders), {
            providers: [
                'emojiProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}
function $1f26990cfea7bc9e$var$EmojiItem(props) {
    const { id: id, providers: providers, shortName: shortName, text: text, fitToHeight: fitToHeight, resourceConfig: resourceConfig } = props;
    const inlineAnnotationProps = (0, $9RWIk.useInlineAnnotationProps)(props);
    if ((0, $fHpHg.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", inlineAnnotationProps, /*#__PURE__*/ (0, $f8Sb3.jsx)($1f26990cfea7bc9e$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    })));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($1f26990cfea7bc9e$var$EmojiNode, {
        allowTextFallback: true,
        id: id,
        shortName: shortName,
        fallback: text,
        providers: providers,
        fitToHeight: fitToHeight,
        resourceConfig: resourceConfig
    });
}
// Working around an issue with pre existing tests using react-test-renderer
// https://github.com/facebook/react/issues/17301#issuecomment-557765213
$1f26990cfea7bc9e$var$EmojiItem.defaultProps = {};
var $1f26990cfea7bc9e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1f26990cfea7bc9e$var$EmojiItem);

});
parcelRegister("fgZWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c863e94b91fe7d9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8JIlu = parcelRequire("8JIlu");

var $952rW = parcelRequire("952rW");

var $2AeLS = parcelRequire("2AeLS");

var $aGRkq = parcelRequire("aGRkq");
const $1c863e94b91fe7d9$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $aGRkq.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $2AeLS.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $952rW.UfoErrorBoundary), {
        experiences: [
            (0, $2AeLS.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JIlu.ResourcedEmojiComponent), {
            ...props
        })
    });
};
var $1c863e94b91fe7d9$export$2e2bcd8739ae039 = $1c863e94b91fe7d9$var$ResourcedEmoji;

});
parcelRegister("8JIlu", function(module, exports) {

$parcel$export(module.exports, "ResourcedEmojiComponent", () => $c236a432f620563b$export$7bfde52eceb3e2f6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lAOer = parcelRequire("lAOer");

var $aGRkq = parcelRequire("aGRkq");

var $70f7p = parcelRequire("70f7p");

var $eyWYN = parcelRequire("eyWYN");

var $1lHCF = parcelRequire("1lHCF");

var $gDljz = parcelRequire("gDljz");

var $2AeLS = parcelRequire("2AeLS");

var $jn7Qb = parcelRequire("jn7Qb");

var $2AeLS = parcelRequire("2AeLS");
var $c236a432f620563b$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($c236a432f620563b$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $c236a432f620563b$export$7bfde52eceb3e2f6 = (props)=>{
    const { emojiProvider: emojiProvider, emojiId: emojiId, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $aGRkq.defaultEmojiHeight), optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji } = props;
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $5uXOq.useState)();
    const [loaded, setLoaded] = (0, $5uXOq.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $5uXOq.useState)(false);
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $5uXOq.useState)();
    const getActiveInterationMetadata = ()=>{
        const activeInteraction = (0, $lAOer.getActiveInteraction)();
        let activeInteractionMetadata = {};
        if (activeInteraction) activeInteractionMetadata = {
            ...activeInteraction.metaData['productInteractionName'] ? {
                productInteractionName: activeInteraction.metaData['productInteractionName']
            } : {},
            ...activeInteraction.metaData['productInteractionType'] ? {
                productInteractionType: activeInteraction.metaData['productInteractionType']
            } : {}
        };
        return activeInteractionMetadata;
    };
    const fetchOrGetEmoji = (0, $5uXOq.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            const activeInteractionMetadata = getActiveInterationMetadata();
            setEmoji(undefined);
            (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: 'missing fetchByEmojiId interface',
                    source: 'ResourcedEmojiComponent',
                    ...activeInteractionMetadata
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch);
        (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).mark((0, $eyWYN.UfoEmojiTimings).METADATA_START);
        if ((0, $70f7p.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    // emoji is undefined
                    const activeInteractionMetadata = getActiveInterationMetadata();
                    (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: 'failed to find',
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            },
                            ...activeInteractionMetadata
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const activeInteractionMetadata = getActiveInterationMetadata();
                (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: 'failed to load',
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        },
                        ...activeInteractionMetadata
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).mark((0, $eyWYN.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).mark((0, $eyWYN.UfoEmojiTimings).METADATA_END);
        }
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $2AeLS.hasUfoMarked)((0, $2AeLS.sampledUfoRenderedEmoji)(emojiId), (0, $eyWYN.UfoEmojiTimings).FMP_END)) (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]);
    (0, $5uXOq.useMemo)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]);
    /**
	 * Setting resolved emoji provider for optimistic rendering
	 */ (0, $5uXOq.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $5uXOq.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $5uXOq.useMemo)(()=>{
        if (optimisticImageURL) {
            if (emoji && ((0, $70f7p.isImageRepresentation)(emoji.representation) || (0, $70f7p.isMediaRepresentation)(emoji?.representation))) {
                const { width: width, height: height } = emoji.representation;
                return {
                    ...emoji,
                    representation: {
                        width: width,
                        height: height,
                        imagePath: optimisticImageURL
                    }
                };
            } else return {
                id: id,
                shortName: shortName,
                fallback: fallback,
                type: '',
                category: '',
                representation: {
                    height: fitToHeight || (0, $aGRkq.defaultEmojiHeight),
                    width: fitToHeight || (0, $aGRkq.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName
    ]);
    const handleOnLoadError = (0, $5uXOq.useCallback)((emojiId)=>{
        const activeInteractionMetadata = getActiveInterationMetadata();
        setImageLoadError(true);
        (0, $2AeLS.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id,
                ...activeInteractionMetadata
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jn7Qb.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            "data-emoji-id": id,
            "data-emoji-short-name": shortName,
            "data-emoji-text": fallback || shortName,
            children: [
                emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gDljz.default), {
                    shortName: shortName,
                    showTooltip: showTooltip,
                    size: fitToHeight || (0, $aGRkq.defaultEmojiHeight),
                    loading: true
                }),
                emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: customFallback || fallback || shortName
                }),
                emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lHCF.default), {
                    emoji: optimisticEmojiDescription,
                    onLoadError: handleOnLoadError,
                    showTooltip: showTooltip,
                    fitToHeight: fitToHeight,
                    autoWidth: !!emoji ? false : true,
                    editorEmoji: editorEmoji
                })
            ]
        })
    });
};
var $c236a432f620563b$export$2e2bcd8739ae039 = $c236a432f620563b$export$7bfde52eceb3e2f6;

});
parcelRegister("aGRkq", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $7c05402a19db203c$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $7c05402a19db203c$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $7c05402a19db203c$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $7c05402a19db203c$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $7c05402a19db203c$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $7c05402a19db203c$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $7c05402a19db203c$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $7c05402a19db203c$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $7c05402a19db203c$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $7c05402a19db203c$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $7c05402a19db203c$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $7c05402a19db203c$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $7c05402a19db203c$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $7c05402a19db203c$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $7c05402a19db203c$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $7c05402a19db203c$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $7c05402a19db203c$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $7c05402a19db203c$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $7c05402a19db203c$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $7c05402a19db203c$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $7c05402a19db203c$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $7c05402a19db203c$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $7c05402a19db203c$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $7c05402a19db203c$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $7c05402a19db203c$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $7c05402a19db203c$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $7c05402a19db203c$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $7c05402a19db203c$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $7c05402a19db203c$export$66cabad5e268b05e);
const $7c05402a19db203c$export$5e4e3d1c3e43156a = 'CUSTOM';
const $7c05402a19db203c$export$78ccdc4be403c468 = 'FREQUENT';
const $7c05402a19db203c$export$2c4b04c3aacdf1b3 = 'SITE';
const $7c05402a19db203c$export$1b0258512be88334 = 'SEARCH';
const $7c05402a19db203c$export$42b510423367f354 = 'USER_CUSTOM';
const $7c05402a19db203c$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $7c05402a19db203c$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $7c05402a19db203c$export$8ac325bfd32359b0 = 'data:';
const $7c05402a19db203c$export$a330961542edfe6f = 'delete-emoji';
const $7c05402a19db203c$export$1a817f1886276c6d = 100000;
const $7c05402a19db203c$export$3f99ac31dc0406db = 20;
const $7c05402a19db203c$export$d171dc12fee2b1da = 350;
const $7c05402a19db203c$export$c10ac8125a260041 = 80;
const $7c05402a19db203c$export$5248fb9e0cccc41f = 'medium';
const $7c05402a19db203c$export$94f75d625e7801d3 = 260;
const $7c05402a19db203c$export$7ed599d166d65aea = 295;
const $7c05402a19db203c$export$7722b8e9522021df = $7c05402a19db203c$export$7ed599d166d65aea - 58; // picker height - actions height
const $7c05402a19db203c$export$e218e5cb105a0e22 = 54;
const $7c05402a19db203c$export$e67f617938b111f1 = $7c05402a19db203c$export$7ed599d166d65aea + $7c05402a19db203c$export$e218e5cb105a0e22;
const $7c05402a19db203c$export$e394a0c530ae5631 = 'fabric.emoji';
const $7c05402a19db203c$export$79ee4ef84c545f8f = `${$7c05402a19db203c$export$e394a0c530ae5631}.selectedTone`;
const $7c05402a19db203c$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $7c05402a19db203c$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $7c05402a19db203c$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $7c05402a19db203c$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $7c05402a19db203c$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $7c05402a19db203c$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $7c05402a19db203c$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $7c05402a19db203c$export$4f0ee90b28d6efc5 = 0;
const $7c05402a19db203c$export$9f7de4293d27f3aa = 50;
const $7c05402a19db203c$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $7c05402a19db203c$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $7c05402a19db203c$export$2829f3ec323f8ec0 = 8;
const $7c05402a19db203c$export$ce3a0e7d2d7d6ba2 = 5;
const $7c05402a19db203c$export$858e8dc100a97278 = 150;
const $7c05402a19db203c$export$83aab2ae64548423 = 20;
const $7c05402a19db203c$export$66cabad5e268b05e = 100;

});

parcelRegister("70f7p", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $bea063d0707cb4e1$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $bea063d0707cb4e1$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $bea063d0707cb4e1$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $bea063d0707cb4e1$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $bea063d0707cb4e1$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $bea063d0707cb4e1$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $bea063d0707cb4e1$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $bea063d0707cb4e1$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $bea063d0707cb4e1$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $bea063d0707cb4e1$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $bea063d0707cb4e1$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $bea063d0707cb4e1$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $bea063d0707cb4e1$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $bea063d0707cb4e1$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $bea063d0707cb4e1$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $bea063d0707cb4e1$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $bea063d0707cb4e1$export$4bcbf61cb6832a8e);

var $hbAJx = parcelRequire("hbAJx");

var $aGRkq = parcelRequire("aGRkq");
const $bea063d0707cb4e1$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $bea063d0707cb4e1$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $bea063d0707cb4e1$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $bea063d0707cb4e1$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $bea063d0707cb4e1$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $bea063d0707cb4e1$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $bea063d0707cb4e1$export$a7e82c67204c73a1 = (emoji)=>$bea063d0707cb4e1$export$979133dc1df141c6(emoji.representation);
const $bea063d0707cb4e1$export$7720a4954d6f75f8 = (rep)=>$bea063d0707cb4e1$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $aGRkq.dataURLPrefix)) === 0;
const $bea063d0707cb4e1$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $aGRkq.customCategory) && $bea063d0707cb4e1$export$7720a4954d6f75f8(emoji.representation);
const $bea063d0707cb4e1$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $bea063d0707cb4e1$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $bea063d0707cb4e1$export$dddfba07c16c94d2 = (key)=>key in (0, $hbAJx.messages);
const $bea063d0707cb4e1$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $bea063d0707cb4e1$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $bea063d0707cb4e1$export$8d7d3de6b5b305d1(emoji);
};
const $bea063d0707cb4e1$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $bea063d0707cb4e1$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($bea063d0707cb4e1$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $bea063d0707cb4e1$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $bea063d0707cb4e1$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $bea063d0707cb4e1$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$bea063d0707cb4e1$export$979133dc1df141c6(mediaRepresentation) && !$bea063d0707cb4e1$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $bea063d0707cb4e1$export$979133dc1df141c6(mediaRepresentation) ? $bea063d0707cb4e1$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $bea063d0707cb4e1$export$979133dc1df141c6(mediaAltRepresentation) ? $bea063d0707cb4e1$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $bea063d0707cb4e1$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $bea063d0707cb4e1$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $bea063d0707cb4e1$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("hbAJx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $932ede6470a85285$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $932ede6470a85285$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    /*
	searchResultsStatus: {
		id: 'fabric.emoji.search.status',
		defaultMessage: 'Found {count} emojis',
		description: 'search results status for screenreader to read out',
	},
	 */ searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("eyWYN", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $f70c643b418346ab$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $f70c643b418346ab$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $f70c643b418346ab$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $f70c643b418346ab$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $f70c643b418346ab$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $f70c643b418346ab$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $f70c643b418346ab$export$482549d945a3723);
var $f70c643b418346ab$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $f70c643b418346ab$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $f70c643b418346ab$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $f70c643b418346ab$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $f70c643b418346ab$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $f70c643b418346ab$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $f70c643b418346ab$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("1lHCF", function(module, exports) {

$parcel$export(module.exports, "EmojiNodeWrapper", () => $5ed81e8b5d498fa3$export$ce5eef59d8e46687);
$parcel$export(module.exports, "default", () => $5ed81e8b5d498fa3$export$2e2bcd8739ae039);
/* Emoji.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $2Tr6g = parcelRequire("2Tr6g");

var $aGRkq = parcelRequire("aGRkq");

var $70f7p = parcelRequire("70f7p");

var $eyWYN = parcelRequire("eyWYN");

var $dLQFy = parcelRequire("dLQFy");

var $6FGIp = parcelRequire("6FGIp");


var $2AeLS = parcelRequire("2AeLS");
var $fScLw = parcelRequire("fScLw");

var $2DB0m = parcelRequire("2DB0m");

var $5clt2 = parcelRequire("5clt2");

var $2AeLS = parcelRequire("2AeLS");

var $i76dL = parcelRequire("i76dL");

var $fXR4p = parcelRequire("fXR4p");
const $5ed81e8b5d498fa3$var$emojiSpriteContainer = null;
const $5ed81e8b5d498fa3$var$emojiImageContainer = null;
const $5ed81e8b5d498fa3$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $aGRkq.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $dLQFy.leftClick)(event)) onSelected((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$var$handleKeyDown = (props, event)=>{
    if (!(0, $aGRkq.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $aGRkq.KeyboardKeys).Enter || event.key === (0, $aGRkq.KeyboardKeys).Space)) onSelected((0, $70f7p.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $aGRkq.KeyboardKeys).Backspace) $5ed81e8b5d498fa3$var$handleDelete(props, event);
};
const $5ed81e8b5d498fa3$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$var$handleDelete = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props;
    // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $70f7p.toEmojiId)(emoji), emoji, event);
};
const $5ed81e8b5d498fa3$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $f7dab96e234b935f$export$b06c4aab1d012063)} ${selected ? (0, $f7dab96e234b935f$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $f7dab96e234b935f$export$860109dfd198259b) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) sizing = {
        width: `${fitToHeight}px`,
        height: `${fitToHeight}px`,
        minHeight: `${fitToHeight}px`,
        minWidth: `${fitToHeight}px`
    };
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($5ed81e8b5d498fa3$export$ce5eef59d8e46687, {
        ...props,
        type: "sprite",
        className: classes,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $f7dab96e234b935f$export$1c10634420a08d8a),
            style: style
        })
    }));
};
const $5ed81e8b5d498fa3$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth } = props;
    const [ref, inView] = (0, $5clt2.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $2AeLS.sampledUfoRenderedEmoji)(emoji);
    const classes = `${(0, $f7dab96e234b935f$export$11462c0756c24ab6)} ${(0, $f7dab96e234b935f$export$b06c4aab1d012063)} ${selected ? (0, $f7dab96e234b935f$export$8633a0edef8e95dd) : ''} ${selectOnHover ? (0, $f7dab96e234b935f$export$860109dfd198259b) : ''} ${(0, $f7dab96e234b935f$export$da61cef1c8919f7c)} ${className ? className : ''} ${showDelete ? (0, $f7dab96e234b935f$export$22b19c311e9caa4) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $2Tr6g.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $70f7p.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $70f7p.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) // Presize image, to prevent reflow due to size changes after loading
    sizing = {
        // Size of <img> needs to be deterministic when rendered on server-side. Auto will cause width to be 0 before image is loaded.
        width: autoWidth && !(0, $fXR4p.isSSR)() ? 'auto' : fitToHeight / height * width,
        height: fitToHeight
    };
    const onError = (0, $5uXOq.useCallback)((event)=>{
        $5ed81e8b5d498fa3$var$handleImageError(props, event);
    }, [
        props
    ]);
    const onLoad = (0, $5uXOq.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $eyWYN.UfoEmojiTimings).MOUNTED_END);
        // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, (0, $eyWYN.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $eyWYN.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $eyWYN.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
        // onload_start
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, (0, $eyWYN.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $eyWYN.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $2DB0m.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, (0, $eyWYN.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $eyWYN.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $5uXOq.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!document.activeElement?.contains(e.target)) e.stopPropagation();
    }, []);
    // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $5uXOq.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const emojiNode = /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        //@ts-ignore
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        alt: emoji.name || emoji.shortName,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }, src);
    // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i76dL.DeletableEmojiTooltipContent), {}),
        position: "right-start",
        tag: "span",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($5ed81e8b5d498fa3$export$ce5eef59d8e46687, {
            ...props,
            "aria-labelledby": `screenreader-emoji-${emoji.id}`,
            type: "image",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: classes,
            ref: ref,
            showTooltip: false,
            onMouseOver: onMouseOver,
            children: [
                emojiNode,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6FGIp.default), {
                    onClick: (event)=>$5ed81e8b5d498fa3$var$handleDelete(props, event)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i76dL.DeletableEmojiTooltipContentForScreenReader), {
                    emoji: emoji
                })
            ]
        })
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($5ed81e8b5d498fa3$export$ce5eef59d8e46687, {
        ...props,
        type: "image",
        className: classes,
        ref: ref,
        children: emojiNode
    }));
};
const $5ed81e8b5d498fa3$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, ...other } = props;
    let accessibilityProps;
    if (editorEmoji) accessibilityProps = {
        role: undefined
    };
    else if (shouldBeInteractive) accessibilityProps = {
        role: 'button',
        'aria-label': emoji.shortName
    };
    else accessibilityProps = {
        role: 'img',
        'aria-label': emoji.shortName
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...accessibilityProps,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            type === 'sprite' ? "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _1e0c1o8l _jr50scvx _ylp71o8l _pkaxgktf _1hdcgktf _109tnkob _tn8j14ae _3naf14ae _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc" : "_2rkosqtm _19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _bfhk18uv _1e0c1o8l _s7n4nkob _v4pn1ule _tn8j14ae _3naf14ae _160jewfl _1theewfl _1kogh2mm _qyp0ewfl _nt751r31 _49pcglyw _1hvw1o36 _7ehi1n2i _491113zc",
            className
        ]),
        onKeyDown: (event)=>$5ed81e8b5d498fa3$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $5ed81e8b5d498fa3$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $5ed81e8b5d498fa3$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $5ed81e8b5d498fa3$var$handleFocus(props, event);
        },
        title: showTooltip ? emoji.shortName : undefined,
        ...other,
        children: children
    });
});
const $5ed81e8b5d498fa3$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props;
    // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $fScLw.useSampledUFOComponentExperience)((0, $2AeLS.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $aGRkq.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $5uXOq.useEffect)(()=>{
        const ufoExp = (0, $2AeLS.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $2AeLS.hasUfoMarked)(ufoExp, (0, $eyWYN.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $eyWYN.UfoEmojiTimings).MOUNTED_END);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $70f7p.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, $2OMIu.jsx)($5ed81e8b5d498fa3$export$ef49ddbb198ce334, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5ed81e8b5d498fa3$export$99dfeb9d71c11788, {
        ...props
    });
};
var $5ed81e8b5d498fa3$export$2e2bcd8739ae039 = $5ed81e8b5d498fa3$export$56cc48506ff790a;

});
parcelRegister("2Tr6g", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $cb76297f93cdfcd1$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $cb76297f93cdfcd1$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $cb76297f93cdfcd1$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $cb76297f93cdfcd1$export$b7e9058f156d8d19);

var $ddgvn = parcelRequire("ddgvn");

var $70f7p = parcelRequire("70f7p");

var $5fQjB = parcelRequire("5fQjB");
const $cb76297f93cdfcd1$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $cb76297f93cdfcd1$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $cb76297f93cdfcd1$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $ddgvn.utils).requestService(serviceConfig, requestOptions);
};
const $cb76297f93cdfcd1$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $cb76297f93cdfcd1$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $cb76297f93cdfcd1$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$cb76297f93cdfcd1$var$calculateScale($cb76297f93cdfcd1$export$d39ce20a37bba061).altScale];
};
const $cb76297f93cdfcd1$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $cb76297f93cdfcd1$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $70f7p.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $70f7p.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($cb76297f93cdfcd1$export$db05e6ae1fd416af(imagePath, meta)) return (0, $70f7p.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $5fQjB.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $cb76297f93cdfcd1$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $cb76297f93cdfcd1$export$55077db3efc820aa($cb76297f93cdfcd1$export$4a0301d636367e1d(altReps), meta);
};
const $cb76297f93cdfcd1$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $cb76297f93cdfcd1$export$55077db3efc820aa(representation, meta),
            altRepresentation: $cb76297f93cdfcd1$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $cb76297f93cdfcd1$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $cb76297f93cdfcd1$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $cb76297f93cdfcd1$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $cb76297f93cdfcd1$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $70f7p.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $cb76297f93cdfcd1$var$getHeight = (fitToHeight)=>$cb76297f93cdfcd1$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $cb76297f93cdfcd1$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $cb76297f93cdfcd1$var$getHeight(fitToHeight) > emoji.representation.height);

});
parcelRegister("5fQjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3228ee3c6e22b3a$export$2e2bcd8739ae039);
let $c3228ee3c6e22b3a$var$debugEnabled = false;
let $c3228ee3c6e22b3a$var$stacktracesEnabled = false;
function $c3228ee3c6e22b3a$export$748ada60eaf985cc(enable) {
    $c3228ee3c6e22b3a$var$debugEnabled = enable;
}
function $c3228ee3c6e22b3a$export$4f7017086af31c25(enable) {
    $c3228ee3c6e22b3a$var$stacktracesEnabled = enable;
}
function $c3228ee3c6e22b3a$export$2a858f450a2f66d() {
    if ($c3228ee3c6e22b3a$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $c3228ee3c6e22b3a$export$2e2bcd8739ae039(msg, ...args) {
    if ($c3228ee3c6e22b3a$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});


parcelRegister("dLQFy", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $744507bb8e14d818$export$34ebdaf2c517ae75);
function $744507bb8e14d818$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $744507bb8e14d818$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $744507bb8e14d818$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}

});

parcelRegister("6FGIp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac334eb040ef2b3$export$2e2bcd8739ae039);
/* DeleteButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $1dsdR = parcelRequire("1dsdR");


var $aGRkq = parcelRequire("aGRkq");


var $5sRpy = parcelRequire("5sRpy");
const $fac334eb040ef2b3$var$styles = {
    boxWrapperStyle: "_1bsbf6fq _4t3if6fq"
};
const $fac334eb040ef2b3$var$deleteButton = null;
const $fac334eb040ef2b3$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $fac334eb040ef2b3$var$DeleteButton = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_3um015vq _1e0c1txw _kqswstnw _154ix0bf _1xi2x0bf _1pbykb7n _13t3idpf",
            (0, $f7dab96e234b935f$export$b11fa39b56a371f6)
        ]),
        "data-testid": $fac334eb040ef2b3$export$28fc7374cf1206d4,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $fac334eb040ef2b3$var$styles.boxWrapperStyle,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dsdR))), {
                    label: (0, $aGRkq.deleteEmojiLabel),
                    color: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`,
                    LEGACY_size: "small"
                })
            }),
            onClick: props.onClick,
            // TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
            appearance: "subtle-link",
            spacing: "none",
            testId: "emoji-delete-button",
            tabIndex: -1
        })
    });
var $fac334eb040ef2b3$export$2e2bcd8739ae039 = $fac334eb040ef2b3$var$DeleteButton;

});
parcelRegister("1dsdR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23abdef56045225c72ffa19368031ad5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e2ce5c3d621afa2$var$_react = $0e2ce5c3d621afa2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e2ce5c3d621afa2$var$_crossCircle = $0e2ce5c3d621afa2$var$_interopRequireDefault((parcelRequire("8wCU9")));

var $0e2ce5c3d621afa2$var$_crossCircle2 = $0e2ce5c3d621afa2$var$_interopRequireDefault((parcelRequire("4y6Pt")));
function $0e2ce5c3d621afa2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e2ce5c3d621afa2$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $0e2ce5c3d621afa2$var$_react.default.createElement($0e2ce5c3d621afa2$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $0e2ce5c3d621afa2$var$_crossCircle2.default
    }, props));
$0e2ce5c3d621afa2$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $0e2ce5c3d621afa2$var$_default = module.exports.default = $0e2ce5c3d621afa2$var$CrossCircleIcon;

});

var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';

const $f7dab96e234b935f$export$8633a0edef8e95dd = 'emoji-common-selected';
const $f7dab96e234b935f$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $f7dab96e234b935f$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $f7dab96e234b935f$export$b06c4aab1d012063 = 'emoji-common-node';
const $f7dab96e234b935f$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $f7dab96e234b935f$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $f7dab96e234b935f$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $f7dab96e234b935f$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $f7dab96e234b935f$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $f7dab96e234b935f$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("2AeLS", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $8ef0511a56530f67$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $8ef0511a56530f67$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $8ef0511a56530f67$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $8ef0511a56530f67$export$1466212a1606133);

var $eyWYN = parcelRequire("eyWYN");

var $766ff = parcelRequire("766ff");
var $2DPlK = parcelRequire("2DPlK");
var $88I8J = parcelRequire("88I8J");

var $30bPV = parcelRequire("30bPV");
const $8ef0511a56530f67$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $2DPlK.ExperienceTypes).Load,
        performanceType: (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $8ef0511a56530f67$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $2DPlK.ExperienceTypes).Experience,
        performanceType: (0, $2DPlK.ExperiencePerformanceTypes).InlineResult
    };
};
const $8ef0511a56530f67$var$customEmojiTimings = [
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $eyWYN.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $eyWYN.UfoEmojiTimings).METADATA_START,
        endMark: (0, $eyWYN.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $eyWYN.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $eyWYN.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $eyWYN.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $eyWYN.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $eyWYN.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $eyWYN.UfoEmojiTimings).ONLOAD_END
    }
];
const $8ef0511a56530f67$export$615f888019c45765 = {
    'emoji-rendered': new (0, $766ff.ConcurrentExperience)((0, $eyWYN.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $eyWYN.UfoComponentName).EMOJI
        },
        type: (0, $2DPlK.ExperienceTypes).Operation,
        performanceType: (0, $2DPlK.ExperiencePerformanceTypes).Custom,
        timings: $8ef0511a56530f67$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $766ff.ConcurrentExperience)((0, $eyWYN.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $8ef0511a56530f67$var$createRenderExperience((0, $eyWYN.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $88I8J.UFOExperience)((0, $eyWYN.UfoExperienceName).EMOJI_PICKER_OPENED, $8ef0511a56530f67$var$createRenderExperience((0, $eyWYN.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $88I8J.UFOExperience)((0, $eyWYN.UfoExperienceName).EMOJI_SELECTION_RECORDED, $8ef0511a56530f67$var$createInlineExperience((0, $eyWYN.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $88I8J.UFOExperience)((0, $eyWYN.UfoExperienceName).EMOJI_UPLOADED, $8ef0511a56530f67$var$createInlineExperience((0, $eyWYN.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $88I8J.UFOExperience)((0, $eyWYN.UfoExperienceName).EMOJI_SEARCHED, $8ef0511a56530f67$var$createInlineExperience((0, $eyWYN.UfoComponentName).EMOJI_PICKER))
};
const $8ef0511a56530f67$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $30bPV.withSampling)($8ef0511a56530f67$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $8ef0511a56530f67$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $8ef0511a56530f67$export$1466212a1606133 = (providerType)=>{
    return (0, $30bPV.withSampling)($8ef0511a56530f67$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("766ff", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $da9c8b3012314011$export$ac1cddfee07ba6ac);

var $2wNBQ = parcelRequire("2wNBQ");

var $88I8J = parcelRequire("88I8J");
class $da9c8b3012314011$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $88I8J.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $2wNBQ.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});

parcelRegister("30bPV", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $d4447dd127bc04b1$export$dc2f0946255b3f89);
const $d4447dd127bc04b1$export$c7c4959fece2f3ec = {};
const $d4447dd127bc04b1$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($d4447dd127bc04b1$export$c7c4959fece2f3ec))delete $d4447dd127bc04b1$export$c7c4959fece2f3ec[prop];
};
const $d4447dd127bc04b1$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $d4447dd127bc04b1$var$hasSampledFromStart = (experience)=>{
    if (!$d4447dd127bc04b1$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $d4447dd127bc04b1$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $d4447dd127bc04b1$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $d4447dd127bc04b1$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id]) $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $d4447dd127bc04b1$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $d4447dd127bc04b1$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$d4447dd127bc04b1$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("fScLw", function(module, exports) {

$parcel$export(module.exports, "useSampledUFOComponentExperience", () => $7f956e0ea7aa5bbc$export$f959821a7419dee1);

var $5uXOq = parcelRequire("5uXOq");

var $30bPV = parcelRequire("30bPV");
const $7f956e0ea7aa5bbc$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $7f956e0ea7aa5bbc$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            (0, $30bPV.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $7f956e0ea7aa5bbc$var$useConstructor(()=>{
        (0, $30bPV.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};

});

parcelRegister("2DB0m", function(module, exports) {

$parcel$export(module.exports, "default", () => $15d5f08e13ef5329$export$2e2bcd8739ae039);
const $15d5f08e13ef5329$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $15d5f08e13ef5329$var$result.mac = /Mac/.test(navigator.platform);
    $15d5f08e13ef5329$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $15d5f08e13ef5329$export$2e2bcd8739ae039 = $15d5f08e13ef5329$var$result;

});

parcelRegister("5clt2", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $0a8712b35bbe133f$export$2f62ee6831462844);

var $6ggyj = parcelRequire("6ggyj");

var $2DB0m = parcelRequire("2DB0m");
const $0a8712b35bbe133f$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $6ggyj.useInView)(options);
    if (!(0, $2DB0m.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};

});
parcelRegister("6ggyj", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $48f113a7cf9419a6$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $48f113a7cf9419a6$var$_extends() {
    $48f113a7cf9419a6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48f113a7cf9419a6$var$_extends.apply(this, arguments);
}
function $48f113a7cf9419a6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $48f113a7cf9419a6$var$_setPrototypeOf(subClass, superClass);
}
function $48f113a7cf9419a6$var$_setPrototypeOf(o, p) {
    $48f113a7cf9419a6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $48f113a7cf9419a6$var$_setPrototypeOf(o, p);
}
function $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $48f113a7cf9419a6$var$observerMap = new Map();
var $48f113a7cf9419a6$var$RootIds = new WeakMap();
var $48f113a7cf9419a6$var$rootId = 0;
var $48f113a7cf9419a6$var$unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/ function $48f113a7cf9419a6$export$2ef3a60ee1f37bec(inView) {
    $48f113a7cf9419a6$var$unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */ function $48f113a7cf9419a6$var$getRootId(root) {
    if (!root) return '0';
    if ($48f113a7cf9419a6$var$RootIds.has(root)) return $48f113a7cf9419a6$var$RootIds.get(root);
    $48f113a7cf9419a6$var$rootId += 1;
    $48f113a7cf9419a6$var$RootIds.set(root, $48f113a7cf9419a6$var$rootId.toString());
    return $48f113a7cf9419a6$var$RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */ function $48f113a7cf9419a6$var$optionsToId(options) {
    return Object.keys(options).sort().filter(function(key) {
        return options[key] !== undefined;
    }).map(function(key) {
        return key + "_" + (key === 'root' ? $48f113a7cf9419a6$var$getRootId(options.root) : options[key]);
    }).toString();
}
function $48f113a7cf9419a6$var$createObserver(options) {
    // Create a unique ID for this observer instance, based on the root, root margin and threshold.
    var id = $48f113a7cf9419a6$var$optionsToId(options);
    var instance = $48f113a7cf9419a6$var$observerMap.get(id);
    if (!instance) {
        // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
        var elements = new Map();
        var thresholds;
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                var _elements$get;
                // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
                // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
                var inView = entry.isIntersecting && thresholds.some(function(threshold) {
                    return entry.intersectionRatio >= threshold;
                }); // @ts-ignore support IntersectionObserver v2
                if (options.trackVisibility && typeof entry.isVisible === 'undefined') // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
                // @ts-ignore
                entry.isVisible = inView;
                (_elements$get = elements.get(entry.target)) == null || _elements$get.forEach(function(callback) {
                    callback(inView, entry);
                });
            });
        }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $48f113a7cf9419a6$var$observerMap.set(id, instance);
    }
    return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */ function $48f113a7cf9419a6$export$d1203567a167490e(element, callback, options, fallbackInView) {
    if (options === void 0) options = {};
    if (fallbackInView === void 0) fallbackInView = $48f113a7cf9419a6$var$unsupportedValue;
    if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
        var bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return function() {};
    } // An observer with the same options can be reused, so lets use this fact
    var _createObserver = $48f113a7cf9419a6$var$createObserver(options), id = _createObserver.id, observer = _createObserver.observer, elements = _createObserver.elements; // Register the callback listener for this element
    var callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        // Remove the callback from the callback list
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            // No more callback exists for element, so destroy it
            elements["delete"](element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            // No more elements are being observer by this instance, so destroy it
            observer.disconnect();
            $48f113a7cf9419a6$var$observerMap["delete"](id);
        }
    };
}
var $48f113a7cf9419a6$var$_excluded = [
    "children",
    "as",
    "triggerOnce",
    "threshold",
    "root",
    "rootMargin",
    "onChange",
    "skip",
    "trackVisibility",
    "delay",
    "initialInView",
    "fallbackInView"
];
function $48f113a7cf9419a6$var$isPlainChildren(props) {
    return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */ var $48f113a7cf9419a6$export$a62107ca74432f44 = /*#__PURE__*/ function(_React$Component) {
    $48f113a7cf9419a6$var$_inheritsLoose(InView, _React$Component);
    function InView(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.node = null;
        _this._unobserveCb = null;
        _this.handleNode = function(node) {
            if (_this.node) {
                // Clear the old observer, before we start observing a new element
                _this.unobserve();
                if (!node && !_this.props.triggerOnce && !_this.props.skip) // Reset the state if we get a new node, and we aren't ignoring updates
                _this.setState({
                    inView: !!_this.props.initialInView,
                    entry: undefined
                });
            }
            _this.node = node ? node : null;
            _this.observeNode();
        };
        _this.handleChange = function(inView, entry) {
            if (inView && _this.props.triggerOnce) // If `triggerOnce` is true, we should stop observing the element.
            _this.unobserve();
            if (!$48f113a7cf9419a6$var$isPlainChildren(_this.props)) // Store the current State, so we can pass it to the children in the next render update
            // There's no reason to update the state for plain children, since it's not used in the rendering.
            _this.setState({
                inView: inView,
                entry: entry
            });
            if (_this.props.onChange) // If the user is actively listening for onChange, always trigger it
            _this.props.onChange(inView, entry);
        };
        _this.state = {
            inView: !!props.initialInView,
            entry: undefined
        };
        return _this;
    }
    var _proto = InView.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        // If a IntersectionObserver option changed, reinit the observer
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
        this.node = null;
    };
    _proto.observeNode = function observeNode() {
        if (!this.node || this.props.skip) return;
        var _this$props = this.props, threshold = _this$props.threshold, root = _this$props.root, rootMargin = _this$props.rootMargin, trackVisibility = _this$props.trackVisibility, delay = _this$props.delay, fallbackInView = _this$props.fallbackInView;
        this._unobserveCb = $48f113a7cf9419a6$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    };
    _proto.unobserve = function unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    };
    _proto.render = function render() {
        if (!$48f113a7cf9419a6$var$isPlainChildren(this.props)) {
            var _this$state = this.state, inView = _this$state.inView, entry = _this$state.entry;
            return this.props.children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        var _this$props2 = this.props, children = _this$props2.children, as = _this$props2.as, props = $48f113a7cf9419a6$var$_objectWithoutPropertiesLoose(_this$props2, $48f113a7cf9419a6$var$_excluded);
        return /*#__PURE__*/ $5uXOq.createElement(as || 'div', $48f113a7cf9419a6$var$_extends({
            ref: this.handleNode
        }, props), children);
    };
    return InView;
}($5uXOq.Component);
$48f113a7cf9419a6$export$a62107ca74432f44.displayName = 'InView';
$48f113a7cf9419a6$export$a62107ca74432f44.defaultProps = {
    threshold: 0,
    triggerOnce: false,
    initialInView: false
};
/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */ function $48f113a7cf9419a6$export$2f62ee6831462844(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, threshold = _ref.threshold, delay = _ref.delay, trackVisibility = _ref.trackVisibility, rootMargin = _ref.rootMargin, root = _ref.root, triggerOnce = _ref.triggerOnce, skip = _ref.skip, initialInView = _ref.initialInView, fallbackInView = _ref.fallbackInView;
    var unobserve = $5uXOq.useRef();
    var _React$useState = $5uXOq.useState({
        inView: !!initialInView
    }), state = _React$useState[0], setState = _React$useState[1];
    var setRef = $5uXOq.useCallback(function(node) {
        if (unobserve.current !== undefined) {
            unobserve.current();
            unobserve.current = undefined;
        } // Skip creating the observer
        if (skip) return;
        if (node) unobserve.current = $48f113a7cf9419a6$export$d1203567a167490e(node, function(inView, entry) {
            setState({
                inView: inView,
                entry: entry
            });
            if (entry.isIntersecting && triggerOnce && unobserve.current) {
                // If it should only trigger once, unobserve the element after it's inView
                unobserve.current();
                unobserve.current = undefined;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            // @ts-ignore
            trackVisibility: trackVisibility,
            // @ts-ignore
            delay: delay
        }, fallbackInView);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        Array.isArray(threshold) ? threshold.toString() : threshold,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    /* eslint-disable-next-line */ (0, $5uXOq.useEffect)(function() {
        if (!unobserve.current && state.entry && !triggerOnce && !skip) // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
        // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
        setState({
            inView: !!initialInView
        });
    });
    var result = [
        setRef,
        state.inView,
        state.entry
    ]; // Support object destructuring, by adding the specific values.
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


parcelRegister("i76dL", function(module, exports) {

$parcel$export(module.exports, "DeletableEmojiTooltipContent", () => $c46494ee3e3a54ab$export$4727956877b6f612);
$parcel$export(module.exports, "DeletableEmojiTooltipContentForScreenReader", () => $c46494ee3e3a54ab$export$d151e4941072147c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $hbAJx = parcelRequire("hbAJx");

var $frUdK = parcelRequire("frUdK");

var $fGKVg = parcelRequire("fGKVg");

var $cBCgC = parcelRequire("cBCgC");
const $c46494ee3e3a54ab$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $frUdK.ToolTipContentWithKeymap), {
        description: formatMessage((0, $hbAJx.messages).deleteEmojiTooltip),
        keymap: (0, $fGKVg.backspace)
    });
};
const $c46494ee3e3a54ab$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
        id: `screenreader-emoji-${emoji.id}`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $hbAJx.messages).deleteEmojiTooltipForScreenreader,
            values: {
                shortName: emoji.shortName
            }
        })
    });
};

});
parcelRegister("frUdK", function(module, exports) {

$parcel$export(module.exports, "ToolTipContentWithKeymap", () => $66a01f220e1ab8cd$export$c7308f5f9ed494ac);
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fGKVg = parcelRequire("fGKVg");
const $66a01f220e1ab8cd$var$tooltipShortcutStyle = null;
const $66a01f220e1ab8cd$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $fGKVg.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            description,
            shortcut && description && '\u00A0',
            shortcut && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_2rko1l7b _bfhk17rn _ca0qidpf _n3tdidpf _19bvv77o _u5f3v77o _jqf61teg"
                ]),
                children: shortcut
            })
        ]
    }) : null;
});

});
parcelRegister("fGKVg", function(module, exports) {

$parcel$export(module.exports, "backspace", () => $c1777725e0091543$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "formatShortcut", () => $c1777725e0091543$export$384a290f8c265cc5);
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $2DB0m = parcelRequire("2DB0m");
const $c1777725e0091543$export$1ea584ca7009bcc1 = $c1777725e0091543$export$7e6b588cc98b34f1('Backspace', 'Backspace');
function $c1777725e0091543$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $c1777725e0091543$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return $c1777725e0091543$export$d8a7f422d8d42038(description, windows, mac, common);
}
const $c1777725e0091543$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
function $c1777725e0091543$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $2DB0m.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $c1777725e0091543$export$8d734690d3a46118[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $2DB0m.default).mac ? '' : '+');
}

});



parcelRegister("fXR4p", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $b9d33ec995e8620b$export$48d7c418edadb60c);

var $6cAn5 = parcelRequire("6cAn5");
function $b9d33ec995e8620b$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});


parcelRegister("gDljz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a48f78cba7df1611$export$2e2bcd8739ae039);
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $aGRkq = parcelRequire("aGRkq");

const $a48f78cba7df1611$var$placeholderContainer = null;
const $a48f78cba7df1611$var$easeSweep = null;
const $a48f78cba7df1611$var$placeholderContainerAnimated = null;
const $a48f78cba7df1611$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
const $a48f78cba7df1611$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $aGRkq.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": $a48f78cba7df1611$export$73987987fac5266b(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkosqtm _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o",
            loading && !(0, $fHpHg.fg)('cc_complexit_fe_remove_emoji_animation') && "",
            loading && !(0, $fHpHg.fg)('cc_complexit_fe_remove_emoji_animation') && "_16qq1t1r _1kt9b3bt _cfu11ule _1cs8stnw _1rusiw92 _kfgt1osq _1mp41osq",
            (0, $f7dab96e234b935f$export$c7187bbd1a7a9244)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $a48f78cba7df1611$export$2e2bcd8739ae039 = $a48f78cba7df1611$var$EmojiPlaceholder;

});

parcelRegister("jn7Qb", function(module, exports) {

$parcel$export(module.exports, "EmojiCommonProvider", () => $e65ab9e7f7a2e270$export$1120e666998e21b5);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $axar6 = parcelRequire("axar6");
const $e65ab9e7f7a2e270$export$1120e666998e21b5 = (props)=>{
    if (props.emojiProvider) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $axar6.EmojiContextProvider), {
        emojiContextValue: {
            emoji: {
                emojiProvider: props.emojiProvider
            }
        },
        children: props.children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: props.children
    });
};

});
parcelRegister("axar6", function(module, exports) {

$parcel$export(module.exports, "EmojiContextProvider", () => $8fa724f441f756f4$export$f4a09143833145ed);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hWKsk = parcelRequire("hWKsk");

var $5fQjB = parcelRequire("5fQjB");
const $8fa724f441f756f4$export$f4a09143833145ed = ({ children: children, emojiContextValue: emojiContextValue })=>{
    const memoizedEmojiContextValue = (0, $5uXOq.useMemo)(()=>emojiContextValue, [
        emojiContextValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // trigger emoji fetching
        async function fetchEmojiProvider() {
            try {
                await memoizedEmojiContextValue?.emoji.emojiProvider.fetchEmojiProvider();
            } catch (error) {
                (0, $5fQjB.default)('fetchEmojiProvider error catched from outside', error);
            }
        }
        if (memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand) {
            const isFetchingOnDemand = memoizedEmojiContextValue?.emoji.emojiProvider.onlyFetchOnDemand();
            if (!isFetchingOnDemand) fetchEmojiProvider();
        } else fetchEmojiProvider();
    }, [
        memoizedEmojiContextValue
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWKsk.EmojiContext).Provider, {
        value: memoizedEmojiContextValue,
        children: children
    });
};

});
parcelRegister("hWKsk", function(module, exports) {

$parcel$export(module.exports, "EmojiContext", () => $38cd28d688d1bf94$export$9fab6c37a453c65e);

var $5uXOq = parcelRequire("5uXOq");
const $38cd28d688d1bf94$export$9fab6c37a453c65e = (0, $5uXOq.createContext)(null);

});




parcelRegister("952rW", function(module, exports) {

$parcel$export(module.exports, "UfoErrorBoundary", () => $3873fecdeb7a570c$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");
class $3873fecdeb7a570c$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error, errorInfo) {
        for (const exp of this.props.experiences){
            const { name: name, message: message } = error;
            const infoStack = errorInfo.componentStack && typeof errorInfo.componentStack !== 'undefined' ? errorInfo.componentStack : undefined;
            exp.failure({
                metadata: {
                    source: 'UfoErrorBoundary',
                    reason: 'error',
                    error: {
                        name: name,
                        message: message,
                        infoStack: infoStack
                    }
                }
            });
        }
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("9RWIk", function(module, exports) {

$parcel$export(module.exports, "useInlineAnnotationProps", () => $2e3407665eab0615$export$11564cda945bb3c9);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $ePOqS = parcelRequire("ePOqS");
function $2e3407665eab0615$export$11564cda945bb3c9(props) {
    const draftPosition = (0, $5uXOq.useContext)((0, $ePOqS.AnnotationsDraftContext));
    if (!(0, $fHpHg.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}

});



//# sourceMappingURL=emoji.955db651.js.map
